import { ReactComponent as WinnersSvg } from "./winners.svg";
import { useEffect } from "react";

function ApplicationComplete(props) {
  const { successUrl, isGeneralOptIn } = props;

  let domainOfSuccessUrl;

  if (successUrl) {
    domainOfSuccessUrl = new URL(successUrl).hostname;
  }

  useEffect(() => {
    if (!successUrl) return;

    const timeoutId = setTimeout(() => {
      document.location.href = successUrl;
    }, 10000);

    // Cleanup function to clear timeout if component unmounts
    return () => {
      clearTimeout(timeoutId);
    };
  }, [successUrl]); // Only run when successUrl changes

  return (
    <article className="vh-100 dt-ns w-100">
      <div className="dtc-ns v-mid tc white ph4-l overflow-x-hidden">
        <WinnersSvg />
        <h1 className="f1-ns lh-title near-black pa2 pa0-l">
          You've successfully signed up for coverage!
        </h1>
        <div className="center tc mw7">
          {isGeneralOptIn ? (
            <p className="f3-ns lh-copy near-black measure pa2 pa0-ns">
              In the next few minutes, you'll receive an email with a signed copy of your disclosure and a welcome
              email with details about your coverage.
            </p>
          ) : (
            <p className="f3-ns lh-copy near-black measure pa2 pa0-ns">
              In the next few minutes, you'll receive an email with a signed copy of your disclosure and a welcome
              email with details including your certificate of insurance.
            </p>
          )}
        </div>

        <div className="center tc mw7">
          {successUrl ? (
            <p className="f5-ns lh-copy mid-gray">
              Redirecting back to{" "}
              {domainOfSuccessUrl ? domainOfSuccessUrl : successUrl}...
            </p>
          ) : (
            !isGeneralOptIn && (
              <p className="f5-ns lh-copy">
                Your certificate of insurance will be emailed to you shortly.
              </p>
            )
          )}
        </div>
      </div>
    </article>
  );
}

export default ApplicationComplete;
